<template>
    <div>
        <div>
            <div class="d-flex flex-column question mb-2">
                <div class="text-muted mr-1 mb-1">Question:</div>
                <TipTap
                    v-model="question.content.question"
                    :menu_items="[]"
                    :readonly="true"
                />
            </div>
        </div>

        <div class="text-muted mb-2">Items:</div>

        <b-list-group>
            <b-list-group-item
                v-for="(item, index) in items_with_values"
                :key="index"
                :class="{'d-flex align-items-center': item.value, 'd-none': !item.value}"
            >
            <div v-html="item.value" class="v-html w-50"></div>
            <div class="flex-fill">
                <font-awesome-icon :icon="['fas', 'arrow-circle-right']" size="lg" />
            </div>
            <div class="flex-fill">
                <b-badge variant="success">{{item.region}}</b-badge>
            </div>

            </b-list-group-item>
        </b-list-group>
    </div>
</template>

<style lang="scss" scoped>
.option:first-child {
    border-top-left-radius: .25rem;
    border-top-right-radius: .25rem;
}
.option + .option {
    margin-top: -1px;
}
.option:last-child {
    border-bottom-left-radius: .25rem;
    border-bottom-right-radius: .25rem;
}
</style>

<script>
export default {
    data: () => ({}),
    props: ['question', 'question_html'],
    components: {
        TipTap: () => import('@/components/tiptap/TipTap')
    },
    computed: {
        items_with_values () {
            let items = []
            _.each(this.question.content.items, item => {
                if (item.value) {
                    let i = {value: '', region: item.region}
                    i.value = item.value.replaceAll('<merlin-img', '<img')
                    i.value = i.value.replaceAll('</merlin-img', '</img')
                    items.push(i)
                }
            })
            return items
        }
    },
    methods: {}
}
</script>
